import React, { useState } from 'react';
import { Task } from '@models/task.model';
import { Card } from '@components/atoms/Card';
import { Badge } from '@components/atoms/Badge';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import { SmallDocumentList } from '@components/molecules/SmallDocumentList';

interface TaskDetailDocumentsProps {
  task: Task | null;
}

export const TaskDetailDocuments: React.FC<TaskDetailDocumentsProps> = ({
  task,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const documents = task?.documents || [];

  if (documents.length === 0) {
    return null;
  }

  return (
    <Card className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-semibold text-gray-900 dark:text-white">
            Documents
          </h3>
          <Badge variant="secondary" size="sm">
            {documents.length}
          </Badge>
        </div>

        <div onClick={() => setIsCollapsed(!isCollapsed)}>
          {isCollapsed ? (
            <ExpandMoreOutlinedIcon />
          ) : (
            <ExpandLessOutlinedIcon />
          )}
        </div>
      </div>

      {!isCollapsed && <SmallDocumentList documents={documents} />}
    </Card>
  );
};

export default TaskDetailDocuments;
